import { FC } from 'react';

import { Skeleton } from 'ui/skeleton';
import { BrandAffinityLevel } from 'modules/domains/brandAffinity';

import { BrandAffinityIcon } from './BrandAffinityIcon';
import { Card, ContentDivider, RowDivider, SkeletonRow } from '../Styles';
import { BodyRow, HeaderText, SkeletonContainer } from './ScoreCard.styles';

export const ScoreSkeleton: FC = () => {
  return (
    <Card data-test="brand-affinity-xai-score-skeleton">
      <SkeletonContainer>
        <SkeletonRow>
          <BrandAffinityIcon isCurrentScore label={BrandAffinityLevel.UNSCORED} />
          <HeaderText>
            <Skeleton height={34} width={200} />
            <Skeleton height={16} width={150} />
          </HeaderText>
        </SkeletonRow>
        <ContentDivider />
        <BodyRow>
          <BrandAffinityIcon label={BrandAffinityLevel.UNSCORED} />
          <Skeleton height={20} width={150} />
        </BodyRow>
        <RowDivider>&#8942;</RowDivider>
        <BodyRow>
          <BrandAffinityIcon label={BrandAffinityLevel.UNSCORED} />
          <Skeleton height={20} width={150} />
        </BodyRow>
        <RowDivider>&#8942;</RowDivider>
        <BodyRow>
          <BrandAffinityIcon label={BrandAffinityLevel.UNSCORED} />
          <Skeleton height={20} width={150} />
        </BodyRow>
      </SkeletonContainer>
    </Card>
  );
};
